import { combine, createEvent } from 'effector'
import { model as i18nModel } from '~/core/i18n'
import { register } from '~/core/repository'
import { model as languagesModel } from '~/entities/languages'

export const init = createEvent()

const $activeLanguage = combine(
  languagesModel.$languages,
  i18nModel.$locale,
  (languages, activeLanguage) =>
    languages?.find(({ id }) => id === activeLanguage) ?? languages?.[0] ?? null
)

register(languagesModel.$languages, '$languages')
register(i18nModel.languageChange, 'changeLanguage')
register($activeLanguage, '$activeLanguage')
